import { WEB_APPS_LIST_BY_NAME } from "../../modules/AppWrapper2/types.js";
// src/utils/URL-profile/make-profile-notification-URL.ts
var PROFILE_NOTIFICATION_PATH = `${WEB_APPS_LIST_BY_NAME.PROFILE.link}/notifications/:notificationId`;
function makeProfileNotificationURL(notificationId) {
	if (!notificationId) console.warn("makeProfileNotificationURL: no notificationId provided");
	return PROFILE_NOTIFICATION_PATH.replace(":notificationId", notificationId);
}
function makeProfileNotificationsURL() {
	return `${WEB_APPS_LIST_BY_NAME.PROFILE.link}/notifications`;
}
function makeProfileNotificationSettingsURL() {
	return `${WEB_APPS_LIST_BY_NAME.PROFILE.link}/notifications/settings`;
}
export { makeProfileNotificationSettingsURL, makeProfileNotificationURL, makeProfileNotificationsURL };

//# sourceMappingURL=make-profile-notification-URL.js.map